import React, {useState, useEffect} from 'react';
import {ContenedorFiltros,Contenedor, Formulario,Input,Btn, Icono, ContenedorDoble } from '../elementos/ElementosDeFormularioCreaViaje';
import Boton from './../elementos/Boton';
import {ReactComponent as IconoPlus} from './../imagenes/plus.svg';
import {db} from '../firebase/firebaseConfig';
import { ref, orderByChild, equalTo,query, onValue, push, set, limitToFirst,startAt,endAt } from "firebase/database";
import {ContenedorNuevaDireccion,ContenedorSubtituloPequeño, ContenedorOrigen, ContenedorDestino,ContenedorSubtitulo, Subtitulo, ContenedorBoton,Lista,
    Descripcion,
    ContenedorBotonesl,
    BotonAccion,ContenedorInputconLabel,BotonAgragaPasajero,SubtituloPequeño,
    ElementoListad} from './../elementos/ElementosDeFormularioCreaViaje';
import PlacesAutocomplete, {geocodeByAddress,getLatLng,} from 'react-places-autocomplete';
import Alerta from './../elementos/Alerta'
import SelectClientes from './SelectClientes';
import SelectClientesMutual from './SelectClientesMutual';
import SelectTipoPasajero from './SelectTipoPasajero';
import { v4 as uuidv4 } from 'uuid';
import Iconotipo from '../elementos/IconoItinerario';
import IconoTipoDireccion from './../elementos/IconoDirecciones'
import { ReactComponent as IconoOrigen } from './../imagenes/origen.svg';
import { ReactComponent as IconoDestino } from './../imagenes/destino.svg';
import { ReactComponent as IconoGoogle } from './../imagenes/direcciongoogle.svg';
import { ReactComponent as IconoSelect } from './../imagenes/flechaizq.svg';
import Toggle from 'react-toggle'
import "react-toggle/style.css"
import DateTimePicker from './DateTimePricker';
import Swal from 'sweetalert2';
import {format, fromUnixTime} from 'date-fns';
import {es} from 'date-fns/locale';

const FormularioViajePasajero = ({itinerario, cambiarItinerario, listadoPasajeros, cambiarListadoPasajeros,fechahoraviaje, cambiarFechahoraviaje, cliente, cambiarCliente,cambiarVerFormularioViaje,Escliente,UsarioLog}) => {
    const searchOptions = {
        region: 'cl',
        language: 'es-419',
        fields: ["address_components", "geometry", "icon", "name"],
        type: ["subway_station","address"]
      }

    const [telefonopb, Cambiartelefonopb] = useState('');
    const [alerta, cambiarAlerta] = useState({});
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
    const [validapasajero, cambiarValidapasajero] = useState(false);
    const [nombrep, Cambiarnombrep] = useState('');
    const [idp, CambiarIdp] = useState('');
    const [telefonop, Cambiartelefonop] = useState('');
    const [empresap, Cambiarempresap] = useState('');
    const [Tipop, CambiarTipop] = useState('');
    const [rfcp, CambiarRfcp] = useState('');
    const [formulariopasajero, cambiarformulariopasajero] = useState(true);
    const [formulariopasajeron, cambiarformulariopasajeron] = useState(true);
    const [formulariopasajerodo, cambiarformulariopasajeroo] = useState(true);
    const [formulariopasajerodd, cambiarformulariopasajerodd] = useState(true);
    const [direccion_o, Cambiardireccion_o] = useState({});
    const [direccion_d, Cambiardireccion_d] = useState({});
    const [pasajeroNuevo, CambiarPasajeroNuevo] = useState(false);  
    const [direccionlista, Cambiardireccionlista] = useState([]);
    const [direcciong, Cambiardirecciong] = useState('');
    const [clientep, cambiarClientep] = useState ('Seleccione Cliente');
    const [retorno, cambiarRetorno] = useState (false);
    const [toogleRetorno, cambiarToogleRetorno] = useState(true);
    const [VerTipoPasajero, cambiarVerTipoPasajero] = useState(true);
    const [fechahoraviajep, cambiarFechahoraviajep] = useState(null);
    const [fechahoraviajepf, cambiarFechahoraviajepf] = useState('');
    const [comentariop, cambiarComentariop] = useState('');
    const [varnum, cambiarVarnum] = useState('');
    const [contador,cambiaContador]=useState(1);;
    const [EstaOrigen, cambiarEstaOrigen] = useState (false);
    const [viajes15, cambiarViajes15] = useState([]);
    const [fecha_hora15, cambiarfecha_hora15] = useState (new Date());


    function toTimestamp(strDate){
        var datum = Date.parse(strDate);
        return datum;
     }

     const formatearFechaHora = (fecha) => {
		return format(fromUnixTime(fecha), "dd 'de' MMMM 'de' yyyy HH':'mm'", {locale: es})
	}

     useEffect (()=>{    
        if(fechahoraviajep !== 'Ingrese Fecha y hora de Viaje' && fechahoraviajep !== '' && fechahoraviajep !== undefined && fechahoraviajep !== null )
        cambiarFechahoraviajepf(toTimestamp(fechahoraviajep))
        cambiarViajes15([])
        
    },[fechahoraviajep]);

// valida si existen viajes en 15 minutos

    useEffect ( ()=>{    
        if(fechahoraviajepf !== null && fechahoraviajepf !== '' && fechahoraviajepf !== undefined)
        {cambiarfecha_hora15(fechahoraviajepf);
    }
    },[direccion_o]);

    useEffect (()=>{
        if(fechahoraviajepf !== null && fechahoraviajepf !== '' && fechahoraviajepf !== undefined)
        {cambiarfecha_hora15(fechahoraviajepf);
           
            
            var fechaInicio15 = Number(fechahoraviajepf)-900000
            var fechaFin15 = Number(fechahoraviajepf)+900000
            
       const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados'),orderByChild('fecha_hora_programada'),startAt(fechaInicio15),endAt(fechaFin15));
        console.log("llama base de viajes");
        return onValue(consulta, (snapshot) => {
           snapshot.forEach((childSnapshot) => {
            const childKey = childSnapshot.key;
            const childData = childSnapshot.val();
            cambiarViajes15((viajes15) => [...viajes15, {...childData, id: childKey}]);
        });
    },{
        onlyOnce: true
      }
    );  }
    },[direccion_o]);



    useEffect (()=>{

        var viajes15filtro = viajes15.filter(item => item.estado !== 'Terminado')
        viajes15filtro = viajes15filtro.filter(item => item.estado !== 'Cancelado')
        //viajes15filtro = viajes15filtro.filter(item => item.id !== id)
        var viajes15filtroPas = ([])
        viajes15filtro.map((viaje) => {
            if(viaje.hasOwnProperty("pasajeros")){
            let pasajeros = Object.keys(viaje.pasajeros).map(function (key) {return {id : key, ...viaje.pasajeros[key]};})
            pasajeros.map((pasajero) => {
                viajes15filtroPas = [...viajes15filtroPas,{ 
                         id_Viaje: viaje.id,
                         Fecha: (viaje.fecha_hora_programada/1000),
                         Estado: viaje.estado,
                         Pasajero_Telefono: pasajero.telefono
                       }
                       ]
                     }
         )}
         })

         var PasajeroViajes = viajes15filtroPas.filter(item => Number(item.Pasajero_Telefono) === Number(telefonop))

        if(PasajeroViajes.length>0){
            Swal.fire({
                title: 'Pasajero Ya Asignado',
                text: 'El numero de telefono ya tiene un traslado en un rango de 15 minutos',
                icon: 'error',
                timer:10000
                })
        } 
    },[viajes15]);

//termano validacion de 15 minutos

    useEffect (()=>{    
        if (telefonopb.substring(0, 1) === "1"){
            cambiarVarnum('5491'+(telefonopb))
        }else{
            cambiarVarnum('56'+(telefonopb))
        }
    },[telefonopb]);
    
    useEffect (()=>{    
        if (empresap === "Mutual Agustinas " ||
        empresap === "Mutual De Seguridad" ||
        empresap === "Mutual Enea" ||
        empresap === "Mutual La Florida" ||
        empresap === "Mutual Lo Espejo" ||
        empresap === "Mutual Maipu" ||
        empresap === "Mutual Paine" ||
        empresap === "Mutual Providencia" ||
        empresap === "Mutual Puente Alto" ||
        empresap === "Mutual Quilicura" ||
        empresap === "MUTUAL SAM615" ||
        empresap === "MUTUAL SCM590" ||
        empresap === "Mutual Las Condes" ||
        empresap === "Mutual Las Tranqueras" ||
        empresap === "Mutual Sindicato" ||
        empresap === "Mutual San Bernardo" ||
        empresap === "Mutual Talagante"
    ){
        cambiarVerTipoPasajero(false)
        } else {
            cambiarVerTipoPasajero(true)
            if(Tipop === '' || Tipop === undefined){
                CambiarTipop('Funcionario')
            }
            }
    },[empresap]);

    useEffect (()=>{    
        if (clientep === "Mutual Agustinas " ||
        clientep === "Mutual De Seguridad" ||
        clientep === "Mutual Enea" ||
        clientep === "Mutual La Florida" ||
        clientep === "Mutual Lo Espejo" ||
        clientep === "Mutual Maipu" ||
        clientep === "Mutual Paine" ||
        clientep === "Mutual Providencia" ||
        clientep === "Mutual Puente Alto" ||
        clientep === "Mutual Quilicura" ||
        clientep === "MUTUAL SAM615" ||
        clientep === "MUTUAL SCM590" ||
        clientep === "Mutual Las Condes" ||
        clientep === "Mutual Las Tranqueras" ||
        clientep === "Mutual Sindicato" ||
        clientep === "Mutual San Bernardo" ||
        clientep === "Mutual Talagante"
    ){
        cambiarVerTipoPasajero(false)
        } else {
            cambiarVerTipoPasajero(true)
            if(Tipop === '' || Tipop === undefined){
                CambiarTipop('Funcionario')
            }
            }
    },[clientep]);



	const handleChange = (e) => {
		if(e.target.name === 'telefonopb'){
			Cambiartelefonopb(e.target.value);
		} else if (e.target.name === 'nombren'){
			Cambiarnombrep(e.target.value);
		}else if (e.target.name === 'empresan'){
			Cambiarempresap(e.target.value);
		} else if (e.target.name === 'rfcn'){
            CambiarRfcp(e.target.value);
        } else if (e.target.name === 'comentariop'){
            cambiarComentariop(e.target.value);
        }
    }
	const handleChangeToogle = (e) => {
        cambiarRetorno(!retorno)
    }

	const onClickOrigen = (e) => {
        e.preventDefault();
       
        if(fechahoraviajep === '' || fechahoraviajep === undefined || fechahoraviajep === null){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por favor ingresa fecha y hora antes de seleccionar Origen',
                icon: 'warning',
                timer:2000
                })
			return;
		}
        cambiarformulariopasajeroo(!formulariopasajerodo);
        cambiarformulariopasajerodd(true);
        
    }

    const onClickDestino = (e) => {
        e.preventDefault();
        if(fechahoraviajep === '' || fechahoraviajep === undefined || fechahoraviajep === null){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por favor ingresa fecha y hora antes de seleccionar Destino',
                icon: 'warning',
                timer:2000
                })
			return;
		}
        cambiarformulariopasajerodd(!formulariopasajerodd);
        cambiarformulariopasajeroo(true);
    }

	
    const handleSubmit = async (e) => {
        e.preventDefault();
      //  console.log(fechahoraviajepf)

		if(nombrep === '' || nombrep === undefined ){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por favor ingresa nombre de pasajero',
                icon: 'error',
                timer:2000
                })
			return;
		}

        if(telefonop === '' || telefonop === undefined){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por favor busca pasajero por teléfono',
                icon: 'error',
                timer:2000
                })
			return;
		}



        if(pasajeroNuevo===false){
        if(empresap === 'Seleccione Cliente' || empresap === undefined){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por favor selecciona cliente',
                icon: 'error',
                timer:2000
                })

			return;
		}}else{
            if(Escliente===true){
                if(clientep === undefined){
                    Swal.fire({
                        title: 'Complete Información',
                        text: 'Por favor selecciona cliente',
                        icon: 'error',
                        timer:2000
                        })
                    return; }
            }else{
            if(clientep === 'Seleccione Cliente' || clientep === undefined){
                Swal.fire({
                    title: 'Complete Información',
                    text: 'Por favor selecciona cliente',
                    icon: 'error',
                    timer:2000
                    })
                return;   
            }}}

            if(direccion_o.Direccion === '' || direccion_o.Direccion === undefined){
                Swal.fire({
                    title: 'Complete Información',
                    text: 'Por favor selecciona dirección de Origen',
                    icon: 'error',
                    timer:2000
                    })
                return;
            }




        
        if(Tipop === '' || Tipop === undefined){
           
           Swal.fire({
                title: 'Complete Información',
                text: 'Por favor selecciona Tipo de Pasajero',
                icon: 'error',
                timer:2000
                })
			return;
		}

        if(direccion_o.Direccion === direccion_d.Direccion){
            Swal.fire({
                title: 'Valide Información',
                text: 'Las Direcciones de Origen y Destino no pueden ser iguales',
                icon: 'error',
                timer:2000
                })
			return;
		}

        if(direccion_d.Direccion === '' || direccion_d.Direccion === undefined){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por favor selecciona dirección de Destino',
                icon: 'error',
                timer:2000
                })
			return;
		}

        if(direccion_d.Longitud === '' || direccion_d.Latitud === '' || direccion_o.Latitud === '' || direccion_o.Longitud === '' ){
			cambiarEstadoAlerta(true);
			cambiarAlerta({
				tipo: 'error',
				mensaje: 'No se pudo agregar pasajero por favor intenta nuevamente'
			});
			return;
		}
        if(direccion_d.Longitud === undefined || direccion_d.Latitud === undefined || direccion_o.Latitud === undefined || direccion_o.Longitud === undefined ){
			cambiarEstadoAlerta(true);
			cambiarAlerta({
				tipo: 'error',
				mensaje: 'No se pudo agregar pasajero por favor intenta nuevamente'
			});
			return;
		}

// Crea Pasajero y lo carga a viaje 
        if(pasajeroNuevo === true){
           // 

           const postListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/pasajeros');
            const newPostRef = push(postListRef);
            set(newPostRef, {
                nombre: nombrep,
                telefono: telefonop,
                empresa: clientep,
                rfc: rfcp,
                tipo: Tipop
            }); 
            const opostListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/pasajeros/'+newPostRef.key+'/direcciones');
            const onewPostRef = push(opostListRef);
            set(onewPostRef, {
                Direccion : direccion_o.Direccion,
                Latitud:direccion_o.Latitud,
                Longitud:direccion_o.Longitud,
                Nombre:'Direccion Frecuente',
               // id: direccion_o.id
            })
    
            const dpostListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/pasajeros/'+newPostRef.key+'/direcciones');
            const dnewPostRef = push(dpostListRef);
            set(dnewPostRef, {
                Direccion : direccion_d.Direccion,
                Latitud:direccion_d.Latitud,
                Longitud:direccion_d.Longitud,
                Nombre:'Direccion Frecuente',
              //  id: direccion_d.id
            })

            cambiarItinerario(
                [...itinerario,
                    {
                        id: uuidv4(),
                        nombre: nombrep, 
                        telefono: telefonop,
                        tipo: "Origen",
                        direccion: direccion_o.Direccion,
                        latitud: direccion_o.Latitud,
                        longitud: direccion_o.Longitud,
                        fechahoraviajep: fechahoraviajepf,
                        comentariop: comentariop,
                        tipop : Tipop,
                        orden: (contador+1)
                    },{
                        id: uuidv4(),
                        nombre:nombrep, 
                        telefono:telefonop,
                        tipo: 'Destino',
                        direccion: direccion_d.Direccion,
                        latitud: direccion_d.Latitud,
                        longitud: direccion_d.Longitud,
                        tipop : Tipop,
                        orden: (contador+1)
                    }
                ]);

                cambiarListadoPasajeros(
                    [...listadoPasajeros,
                        {
                            id: uuidv4(),
                            nombre: nombrep, 
                            telefono: telefonop,
                            cliente: clientep,
                            rfc: rfcp,
                            direccion_o: direccion_o.Direccion,
                            latitud_o: direccion_o.Latitud,
                            longitud_o: direccion_o.Longitud,
                            direccion_d: direccion_d.Direccion,
                            latitud_d: direccion_d.Latitud,
                            longitud_d: direccion_d.Longitud,
                            fechahoraviajep: fechahoraviajepf,
                            comentariop: comentariop,
                            tipop : Tipop,
                            orden: (contador+1)
                        }
                    ]);
                    if(fechahoraviaje===null && fechahoraviajep !==null)
                    {
                    cambiarFechahoraviaje(new Date(fechahoraviajepf))
                    }
                    if(cliente==='Seleccione Cliente' && clientep !=='Seleccione Cliente')
                    {
                      cambiarCliente(clientep)
                    }
                    
          
            cambiarToogleRetorno(true);
            cambiarRetorno(false)
            cambiarformulariopasajero (true);
            cambiarformulariopasajeron (true);
            cambiarformulariopasajeroo(true);
            cambiarformulariopasajerodd(true);
            Cambiartelefonopb('');
            cambiarFechahoraviajep(null);
            cambiarFechahoraviajepf('');
            cambiarComentariop('');
            //CambiarTipop('');
           
            cambiarVerFormularioViaje(false)
            Swal.fire({
                title: 'Pasajero Agregado',
                text: 'Pasajero creado con éxito y registrado a viaje',
                icon: 'success',
                timer:2000
                })

		} 
// Pasajero ya existe y lo carga a viaje        
        else if (pasajeroNuevo === false){
            //cambiaContador(contador+1)
            cambiarformulariopasajero (true);
            cambiarformulariopasajeron (true);
            cambiarformulariopasajeroo(true);
            cambiarformulariopasajerodd(true);
            cambiarItinerario(
                [...itinerario,
                    {
                        id: uuidv4(),
                        nombre: nombrep, 
                        telefono: telefonop,
                        tipo: "Origen",
                        direccion: direccion_o.Direccion,
                        latitud: direccion_o.Latitud,
                        longitud: direccion_o.Longitud,
                        fechahoraviajep: fechahoraviajepf,
                        comentariop: comentariop,
                        tipop : Tipop,
                        orden: (contador+1)
                    },{
                        id: uuidv4(),
                        nombre:nombrep, 
                        telefono:telefonop,
                        tipo: 'Destino',
                        direccion: direccion_d.Direccion,
                        latitud: direccion_d.Latitud,
                        longitud: direccion_d.Longitud,
                        tipop : Tipop,
                        orden:(contador+1)
                    }
                ]);
                // Si la direccion Origen es nueva la carga a listado de direcciones
                if (direccion_o.Nombre==='Frecuente'){
                    const opostListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/pasajeros/'+idp+'/direcciones');
                    const onewPostRef = push(opostListRef);
                    set(onewPostRef, {
                        Direccion : direccion_o.Direccion,
                        Latitud:direccion_o.Latitud,
                        Longitud:direccion_o.Longitud,
                        Nombre:'Direccion Frecuente'
                    })
                }
                // Si la direccion Destino es nueva la carga a listado de direcciones
                if (direccion_d.Nombre==='Frecuente'){    
                    const dpostListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/pasajeros/'+idp+'/direcciones');
                    const dnewPostRef = push(dpostListRef);
                    set(dnewPostRef, {
                        Direccion: direccion_d.Direccion,
                        Latitud: direccion_d.Latitud,
                        Longitud: direccion_d.Longitud,
                        Nombre: 'Direccion Frecuente'
                    })
                }
                cambiarListadoPasajeros(
                    [...listadoPasajeros,
                        {
                            id: uuidv4(),
                            nombre: nombrep, 
                            telefono: telefonop,
                            cliente: empresap,
                            rfc: rfcp,
                            direccion_o: direccion_o.Direccion,
                            latitud_o: direccion_o.Latitud,
                            longitud_o: direccion_o.Longitud,
                            direccion_d: direccion_d.Direccion,
                            latitud_d: direccion_d.Latitud,
                            longitud_d: direccion_d.Longitud,
                            fechahoraviajep: fechahoraviajepf,
                            comentariop: comentariop,
                            tipop : Tipop,
                            orden: (contador+1)
                        }
                    ]);
            if(fechahoraviaje===null && fechahoraviajep !==null)
            {
               cambiarFechahoraviaje(new Date(fechahoraviajepf))
            }
            if(cliente==='Seleccione Cliente' && empresap !=='Seleccione Cliente')
            {
              cambiarCliente(empresap)
                


            }

            cambiarVerFormularioViaje(false)
            Cambiartelefonopb('');
            cambiarRetorno(false);
 //           cambiarEstadoAlerta(true);
            cambiarFechahoraviajep(null);
            cambiarFechahoraviajepf('');
            cambiarComentariop('');
            //CambiarTipop('');
            Swal.fire({
                title: 'Pasajero Agregado',
                text: 'Pasajero registrado a viaje',
                icon: 'success',
                timer:2000
                })
		}

    }   
    

    const handleSelectndo = async (value) => {
        const results = await geocodeByAddress(value);
        const ll = await getLatLng(results[0]);
        var salir = false

// valida que la direccion no este agregada en las frecuentes
        direccionlista.map((direccionl) => {
            if(direccionl.Latitud === ll.lat && direccionl.Longitud === ll.lng)
            { salir = true
            return;
            }})
        if (salir === true)
        {
            Swal.fire({
                title: 'Direccion ya existe',
                text: 'Seleccione la direccion de Origen desde el listado de frecuentes',
                icon: 'info',
                timer:3000
                })
                Cambiardirecciong('')
        }
        else
        {const direccionorigenn = {Direccion: value, Latitud: ll.lat, Longitud: ll.lng, Nombre: "Frecuente"}
        Cambiardireccion_o(direccionorigenn)
        cambiarformulariopasajeroo(true)
        cambiarformulariopasajerodd(true)
        Cambiardirecciong('')}
    }

    const handleSelectndd = async (value) => {
        const results = await geocodeByAddress(value);
        const ll = await getLatLng(results[0]);
        var salir = false
        // valida que la direccion no este agregada en las frecuentes
                direccionlista.map((direccionl) => {
                    if(direccionl.Latitud === ll.lat && direccionl.Longitud === ll.lng)
                    { salir = true
                    return;
                    }})
                if (salir === true)
                {
                    Swal.fire({
                        title: 'Direccion ya existe',
                        text: 'Seleccione la direccion de Destino desde el listado de frecuentes',
                        icon: 'info',
                        timer:3000
                        })
                        Cambiardirecciong('')
                }
                else
                {
        const direcciondestinon = {Direccion: value, Latitud: ll.lat, Longitud: ll.lng, Nombre: "Frecuente"}
        Cambiardireccion_d(direcciondestinon)
        cambiarformulariopasajeroo(true)
        cambiarformulariopasajerodd(true)
        Cambiardirecciong('')}
    }

    const handleClick = (e) => {
		e.preventDefault();
        if(e.target.name === 'seleciona_origen'){
			let direccion_ori = direccionlista.filter(direccion_origen => direccion_origen.id === e.target.value)
            Cambiardireccion_o(direccion_ori[0])
            cambiarformulariopasajeroo(true)
            cambiarformulariopasajerodd(true)
		} else if (e.target.name === 'seleciona_destino'){
            let direccion_des = direccionlista.filter(direccion_destino => direccion_destino.id === e.target.value)
            Cambiardireccion_d(direccion_des[0])
            cambiarformulariopasajeroo(true)
            cambiarformulariopasajerodd(true)
		}
	}

// Al hacer click en buscar numero telefonico de pasajero.    
    const onClicktelefonopb = async (e) => {
        e.preventDefault();
        cambiarEstadoAlerta(false);
        Cambiardireccionlista([]);
		cambiarAlerta({});
        Cambiarnombrep ('');
        Cambiartelefonop ('');
        Cambiarempresap ('');
        cambiarComentariop('');
        //CambiarTipop('');
        CambiarRfcp('');
        Cambiardireccion_o ({});
        Cambiardireccion_d ({});

// Comprobamos del lado del cliente que el campo de numero tiene contenido.
        if(telefonopb === ''){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por Favor ingresa un número telefónico para buscar al pasajero',
                icon: 'error',
                timer:2000
                })

			return;
		}
// Comprobamos del lado del cliente que el telefono sea valido.
		const expresionRegular = /^[0-9]{9}$/g;
		if( !expresionRegular.test(telefonopb) ){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por favor ingresa teléfono con 9 dígitos sin incluir el +56',
                icon: 'error',
                timer:2000
                })
			return;
		}

// Comprobamos del lado del cliente que el cliente no esta en el viaje actual.
        if( validapasajero === true && retorno === false){
            Swal.fire({
                title: 'Valide Información',
                text: 'El pasajero ya está en el viaje, se es un retorno para el mismo pasajero, activé la opción de retorno',
                icon: 'warning',
                timer:2000
                })
            cambiarValidapasajero(false);
            Cambiartelefonopb('');
            cambiarToogleRetorno(false);
            return;
        }      


        
        if(telefonopb.length === 9) {
            
                       
            const consulta = query (ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/pasajeros'), orderByChild('telefono'), equalTo(Number(varnum)), limitToFirst(1));
            
            onValue (consulta, (snapshot) => {
                   let records = [];
                   snapshot.forEach((childSnapshot) => {
                   const childKey = childSnapshot.key;
                   const childData = childSnapshot.val();
                   records.push({...childData,id: childKey}) 
                   });
                        if (records.length > 0) {
                        cambiarformulariopasajero (false);
                        cambiarformulariopasajeron (true);
                        cambiarformulariopasajerodd(true);
                        cambiarformulariopasajeroo(true);
                        CambiarIdp(records[0].id);
                        Cambiarnombrep (records[0].nombre);
                        Cambiartelefonop (records[0].telefono);
                        if(Escliente===true){
                            Cambiarempresap (UsarioLog.cliente);
                        }else{
                            Cambiarempresap (records[0].empresa);
                        }
                        CambiarTipop(records[0].tipo)
                        CambiarRfcp (records[0].rfc);
                        const pasajerodir = records[0].direcciones
                        if (pasajerodir !== undefined){
                        if (Object.keys(pasajerodir).length>0){
                        const direccion = Object.keys(pasajerodir).map(function (key) {return {id : key, ...pasajerodir[key]};});
                        Cambiardireccionlista (direccion);
                    }}
                        
                        CambiarPasajeroNuevo(false)
                        cambiarToogleRetorno(true)
                        }
                        else{
                            Swal.fire({
                                title: 'Aviso de creación',
                                text: 'El número telefónico no está registrado, se debe crear al pasajero',
                                icon: 'warning',
                                timer:2000
                                })
                            Cambiarnombrep ('');
                            Cambiartelefonop ('');
                            if(Escliente===true){
                                Cambiarempresap (UsarioLog.cliente);
                            }else{
                                Cambiarempresap ('');
                            }
                            CambiarRfcp('');
                            //CambiarTipop('');
                            Cambiardireccion_o ({});
                            Cambiardireccion_d ({});
                            cambiarformulariopasajero (true);
                            cambiarformulariopasajeron(false);
                            cambiarformulariopasajeroo(true);
                            cambiarformulariopasajerodd(true);
                            Cambiartelefonop (Number(varnum));
                            CambiarPasajeroNuevo(true)
                            cambiarToogleRetorno(true)
                        }
                     })
          }
        
        
        }

    useEffect (()=>{    
        Cambiarnombrep ('');
        Cambiartelefonop ('');
        Cambiarempresap ('');
        //CambiarTipop('');
        cambiarValidapasajero(false);
        CambiarRfcp('');
        Cambiardireccion_o ({Direccion:''});
        Cambiardireccion_d ({Direccion:''});
        Cambiardireccionlista([]);
        if (listadoPasajeros.length>0){
            listadoPasajeros.map(pasajerolistado =>{
                if(Number(pasajerolistado.telefono) === Number('56'+(telefonopb)))
                    {cambiarValidapasajero(true);}
                 });
			}
    },[telefonopb]);
    

useEffect (()=>{    
      const ultimoPasajero = itinerario.reduce(
        (prev, cur) => (prev?.orden > cur.orden ? prev : cur),
        {orden: 0}
      );
      cambiaContador(ultimoPasajero.orden);
},[itinerario]);


//console.log(Escliente)

    return (  
        <Formulario onSubmit={handleSubmit}>
            <ContenedorDoble>
                <main>
                <ContenedorSubtitulo><Subtitulo>Datos de Pasajero</Subtitulo></ContenedorSubtitulo>    
                <ContenedorFiltros>
                <ContenedorInputconLabel><p>Telefono busca pasajero</p><Input name="telefonopb" type="text" placeholder="Telefono Pasajero" value={telefonopb} onChange={handleChange}/></ContenedorInputconLabel>
                    <Btn onClick={onClicktelefonopb}><Icono/></Btn>
                </ContenedorFiltros>
                <div hidden={toogleRetorno}>
                <Toggle
                    id='cheese-status'
                    defaultChecked={retorno}
                    onChange={handleChangeToogle}/>
                    <label htmlFor='cheese-status'>&nbsp;&nbsp;Active si es un retorno</label>
                    </div>

            {/* formulario Pasajero existente}*/}
                <div hidden={formulariopasajero}>
                <ContenedorInputconLabel><p>Seleccione Fecha - Hora</p><DateTimePicker fechahoraviaje={fechahoraviajep} cambiarFechahoraviaje={cambiarFechahoraviajep}/></ContenedorInputconLabel>
                <ContenedorInputconLabel><p>Nombre</p><Input name="nombre" type="text" placeholder="Nombre" value={nombrep} disabled = {true}/></ContenedorInputconLabel>    
                <ContenedorInputconLabel><p>Telefono</p><Input name="telefono" type="text" placeholder="Telefono" value={telefonop} disabled = {true}/></ContenedorInputconLabel>   

                {!(Escliente) 
                      ? <ContenedorInputconLabel><p>Empresa</p><SelectClientes cliente={empresap} cambiarCliente={Cambiarempresap}/></ContenedorInputconLabel>
                      : !(UsarioLog.empresa==='Grupo Mutual') 
                      ? <ContenedorInputconLabel><p>Empresa Mutual</p><SelectClientesMutual cliente={empresap} cambiarCliente={Cambiarempresap}/></ContenedorInputconLabel>
                      : <ContenedorInputconLabel><p>Empresa</p><Input name="empresa" type="text" placeholder="Empresa" value={empresap} disabled = {true}/></ContenedorInputconLabel>
                      
                    }


                <div hidden={VerTipoPasajero}><ContenedorInputconLabel><p>Tipo Pasajero</p><SelectTipoPasajero Tipop={Tipop} CambiarTipop={CambiarTipop}/></ContenedorInputconLabel> </div>
                <ContenedorInputconLabel><p>RUT / Centro de Costo</p><Input name="rfc" type="text" placeholder="RUT / Centro de Costo" value={rfcp} disabled = {true}/></ContenedorInputconLabel>      
                <ContenedorFiltros>
                <ContenedorInputconLabel><p>Direccion de Origen</p><Input name="direccion_o" type="text" placeholder="Direccion de Origen" value={direccion_o.Direccion} disabled = {true}/></ContenedorInputconLabel> 
                <Btn onClick={onClickOrigen}><Icono/></Btn>
                </ContenedorFiltros>
                <ContenedorFiltros>
                <ContenedorInputconLabel><p>Direccion de Destino</p><Input name="direccion_d" type="text" placeholder="Direccion de Destino" value={direccion_d.Direccion} disabled = {true}/></ContenedorInputconLabel>   
                <Btn onClick={onClickDestino}><Icono/></Btn>
                </ContenedorFiltros>
               <ContenedorInputconLabel><p>Comentarios</p><Input name="comentariop" type="text" placeholder="Comentario traslado Pasajero" value={comentariop} onChange={handleChange}/></ContenedorInputconLabel>   
            {/* Boton Pasajero Existente}*/}
                
                <ContenedorBoton >
                        <BotonAgragaPasajero as="button" primario conIcono type="submit"> Agregar Pasajero&nbsp;&nbsp;<IconoPlus/></BotonAgragaPasajero>
                </ContenedorBoton>
                
                </div>

            {/* formulario Pasajero Nuevo}*/}
            <div hidden={formulariopasajeron}>
               <ContenedorInputconLabel><p>Seleccione Fecha - Hora</p><DateTimePicker fechahoraviaje={fechahoraviajep} cambiarFechahoraviaje={cambiarFechahoraviajep}/></ContenedorInputconLabel>
                <ContenedorInputconLabel><p>Nombre</p><Input name="nombren" type="text" placeholder="Nombre" value={nombrep} onChange={handleChange}/></ContenedorInputconLabel>    
                <ContenedorInputconLabel><p>Telefono</p><Input name="telefonon" type="text" placeholder="Telefono" value={telefonop} disabled = {true}/></ContenedorInputconLabel>   
                
                
                
                    {!(Escliente) 
                      ? <ContenedorInputconLabel><p>Empresa</p><SelectClientes cliente={clientep} cambiarCliente={cambiarClientep}/></ContenedorInputconLabel>  
                      : <ContenedorInputconLabel><p>Empresa</p><Input name="empresa" type="text" placeholder="Empresa" value={empresap} disabled = {true}/></ContenedorInputconLabel>
                    }
                

                <div hidden={VerTipoPasajero}><ContenedorInputconLabel><p>Tipo Pasajero</p><SelectTipoPasajero Tipop={Tipop} CambiarTipop={CambiarTipop}/></ContenedorInputconLabel></div>
                

                <ContenedorInputconLabel><p>RUT /Centro de Costo</p><Input name="rfcn" type="text" placeholder="RUT / Centro de Costo" value={rfcp} onChange={handleChange}/></ContenedorInputconLabel> 
                <ContenedorFiltros>
                <ContenedorInputconLabel><p>Direccion de Origen</p><Input name="direccion_o" type="text" placeholder="Direccion de Origen" value={direccion_o.Direccion} disabled = {true}/></ContenedorInputconLabel> 
                <Btn onClick={onClickOrigen}><Icono/></Btn>
                </ContenedorFiltros>
                <ContenedorFiltros>
                <ContenedorInputconLabel><p>Direccion de Destino</p><Input name="direccion_d" type="text" placeholder="Direccion de Destino" value={direccion_d.Direccion} disabled = {true}/></ContenedorInputconLabel> 
                <Btn onClick={onClickDestino}><Icono/></Btn>
                </ContenedorFiltros>   
                <ContenedorInputconLabel><p>Comentarios</p><Input name="comentariop" type="text" placeholder="Comentario traslado Pasajero" value={comentariop} onChange={handleChange}/></ContenedorInputconLabel>  
             {/* Boton Pasajero Nuevo}*/}               
                <ContenedorBoton>
                        <BotonAgragaPasajero as="button" primario conIcono type="submit"> Agregar Pasajero&nbsp;&nbsp;<IconoPlus/></BotonAgragaPasajero>
                </ContenedorBoton>
            </div>
            </main>

            <aside>

             {/* formulario direccion de Origen}*/}
                <div hidden={formulariopasajerodo}>    

                    <ContenedorSubtitulo><Subtitulo>Direccion de Origen &nbsp;&nbsp; <IconoOrigen fill="white"/></Subtitulo></ContenedorSubtitulo>
                 
                    
                <div>
                    
                    <ContenedorSubtituloPequeño> <SubtituloPequeño>Buscar Nueva Direccion</SubtituloPequeño></ContenedorSubtituloPequeño>
                <ContenedorNuevaDireccion>

                    <PlacesAutocomplete 
                    name="direccion_o_p_e"
                    value={direcciong}
                    onChange={Cambiardirecciong}
                    onSelect={handleSelectndo}
                    searchOptions={searchOptions}>
                    {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                    <div>
                        <input style={{width: "95%", border: "none", textTransform: 'uppercase'}}
                        {...getInputProps({ placeholder: "Ingrese Direccion Nueva"})}/>
                        <div>
                            {loading ? <div>...Cargando</div> : null}
                            {suggestions.map(suggestion => {
                                const style = {
                                    backgroundColor: suggestion.active ? "#CBDDE2" : "#E8EFF1",
                                };
                                return (
                                <div {...getSuggestionItemProps(suggestion,{style})}><IconoTipoDireccion tipo={suggestion.types}/>-{suggestion.description}</div>
                                );
                        })}
                        </div>
                    </div>
                    )}

                    </PlacesAutocomplete>
                    <IconoGoogle  fill="green"/>
                    </ContenedorNuevaDireccion>
                    <ContenedorSubtituloPequeño> <SubtituloPequeño>Lista de Frecuentes</SubtituloPequeño></ContenedorSubtituloPequeño></div>
               
                    <Lista>
                    {direccionlista.map((direccionl) => {
                    return(  
                        <ElementoListad key={direccionl.id} >        
                            <ContenedorBotonesl >
                                <BotonAccion name="seleciona_origen" onClick={handleClick} value={direccionl.id}></BotonAccion>
                                <Descripcion >{direccionl.Direccion} </Descripcion>
                            </ContenedorBotonesl>
                        </ElementoListad>
                            )
                    })}
                    </Lista>
                </div>

             {/* formulario direccion de Destino}*/}
             <div hidden={formulariopasajerodd}>    
                    <ContenedorSubtitulo><Subtitulo>Direccion de Destino &nbsp;&nbsp; <IconoDestino fill="white"/></Subtitulo></ContenedorSubtitulo>
                    
                    <div border-bottom = '2px solid #CBDDE2'>
                    <ContenedorSubtituloPequeño> <SubtituloPequeño>Buscar Nueva Direccion</SubtituloPequeño></ContenedorSubtituloPequeño>                    

                    <ContenedorNuevaDireccion>
                    <PlacesAutocomplete 
                    name="direccion_d_p_e"
                    value={direcciong}
                    onChange={Cambiardirecciong} 
                    onSelect={handleSelectndd}
                    searchOptions={searchOptions}>
                    {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                    <div>
                        <input style={{width: "95%", border: "none"}}{...getInputProps({ placeholder: "Ingrese Direccion Nueva"})}/>
                        <div>
                            {loading ? <div>...Cargando</div> : null}
                            {suggestions.map(suggestion => {
                                const style = {
                                    backgroundColor: suggestion.active ? "#CBDDE2" : "#E8EFF1",
                                };
                                return (
                                <div {...getSuggestionItemProps(suggestion,{style})}><IconoTipoDireccion tipo={suggestion.types}/>-{suggestion.description}</div>
                                );
                        })}
                        </div>
                    </div>
                    )}
                    </PlacesAutocomplete>
                    <IconoGoogle fill='orange'/>
                    </ContenedorNuevaDireccion>
                    <ContenedorSubtituloPequeño> <SubtituloPequeño>Lista de Frecuentes</SubtituloPequeño></ContenedorSubtituloPequeño>
                    </div>
                    <Lista>
                    {direccionlista.map((direccionl) => {
                    return(
                        <ElementoListad key={direccionl.id}>
                            <ContenedorBotonesl>
                                <BotonAccion name="seleciona_destino" onClick={handleClick} value={direccionl.id}/>
                                <Descripcion>{direccionl.Direccion} </Descripcion>
                            </ContenedorBotonesl>
                        </ElementoListad>
                        )
                    })}
                    </Lista>
                </div>



                </aside>



            </ContenedorDoble>
            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                cambiarEstadoAlerta={cambiarEstadoAlerta}
            />
        </Formulario>
  
                    

            

  

        
    );
}

export default FormularioViajePasajero;